import styled from 'styled-components';
import { Stack } from '@mui/material';

export const DivStack = styled(Stack)`
  color: grey;
  margin: auto;
`;
